import { FC, useState } from "react";
import { APP } from "../../Utils/Constants.ts";
import Select from "react-select";

interface DomainsProps {
  datas: TaxonomyTerm[];
  handleDomains: (filterId: string, value: any) => void;
  value: any;
}

function isEmpty(value: any) {
  return (
    value == null ||
    (typeof value === 'string' && value.trim().length === 0) ||
    (Array.isArray(value) && value.length === 0) ||
    (typeof value === 'object' && Object.keys(value).length === 0)
  );
}

const Domains: FC<DomainsProps> = ({ datas, handleDomains, value }) => {

  const [menuOpen, setMenuOpen] = useState(false);

  // Native button for removing a selected item with keyboard support
  const MultiValueRemove = (props: any) => {
    const { innerProps, data } = props;

    const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        innerProps.onClick?.(e);
      }
    };

    return (
      <button
        type="button"
        {...innerProps}
        onKeyDown={handleKeyDown}
        aria-label={`Supprimer ${data.label}`}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '0 5px',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        ×
      </button>
    );
  };

  // Native button for clearing all selected values with keyboard support
  const ClearIndicator = (props: any) => {
    const { innerProps, clearValue } = props;

    const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        clearValue();
      }
    };

    return (
      <button
        type="button"
        {...innerProps}
        onKeyDown={handleKeyDown}
        aria-label="Vider le champ"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer'
        }}
      >
        ×
      </button>
    );
  };

  const getOption = (options: TaxonomyTerm[]) => {
    const data: { value: string; label: string }[] = [];

    options.forEach((element: any) => {
      data.push({
        value: element.attributes.slug,
        label: element.attributes.name
      });
    });

    data.sort((a, b) => a.label.localeCompare(b.label));

    return data;
  };

  const optionValue = getOption(datas);

  const getSelectedValue = (values: Filter) => {
    let selectedValues: ({ value: string; label: string } | undefined)[] = [];

    if (!isEmpty(values)) {
      values.values.forEach((value: string) => {
        const val = optionValue.find((option) => option.value === value);
        selectedValues.push(val);
      });
    }

    return selectedValues;
  };

  const handleChange = (value: any) => {
    handleDomains(APP.FILTER.DOMAINS.FIELD, value);
    setMenuOpen(false);
  };

  // Handle keyboard interaction for opening the menu
  // Ignore events coming from internal buttons
  const handleKeyDown = (e: React.KeyboardEvent) => {
    const target = e.target as HTMLElement;

    if (target.closest('button')) return;

    if ((e.key === 'Enter' || e.key === ' ') && !menuOpen) {
      e.preventDefault();
      setMenuOpen(true);
    }
  };

  return (
    <div className="filter-wrapper place-input">
      <label htmlFor="filter-domains" className="filter-label">
        {Drupal.t("Domaine d'activité")}
      </label>

      <Select
        inputId="filter-domains"
        isMulti
        value={getSelectedValue(value)}
        placeholder={Drupal.t("Domaine")}
        onChange={handleChange}
        options={optionValue}

        menuIsOpen={menuOpen}
        onMenuOpen={() => setMenuOpen(true)}
        onMenuClose={() => setMenuOpen(false)}
        onKeyDown={handleKeyDown}

        components={{
          MultiValueRemove,
          ClearIndicator
        }}
      />
    </div>
  );
};

export default Domains;